export default __webpack_public_path__ + "static/webRotator/svg/2366d3dd503d8409b4d85b3a9aa5f0cc.svg";